import { Phone, Mail, MapPin, FileText, CreditCard } from 'lucide-react';
import { JSX } from 'react';

type FooterBadge = {
  readonly alt: string;
  readonly src: string;
  readonly orderClass: string;
};

const footerBadges: readonly FooterBadge[] = [
  {
    alt: 'Sportkaart logo',
    src: '/images/Sportkaart.jpg',
    orderClass: 'order-1',
  },
  {
    alt: 'Gelrepas logo',
    src: '/images/Gelrepas.jpg',
    orderClass: 'order-2',
  },
  {
    alt: 'Keurmerk Arnhem logo',
    src: '/images/Keurmerk.jpg',
    orderClass: 'order-3',
  },
] as const;

export default function Footer(): JSX.Element {
  return (
    <footer className="bg-[#411217] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-2">
              <p className="flex items-center"><Phone className="h-5 w-5 mr-2" /> 06-12471413</p>
              <a href="mailto:info@anshin-aikido.nl" className="flex items-center hover:text-gray-300 transition-colors"><Mail className="h-5 w-5 mr-2" /> info@anshin-aikido.nl</a>
              <p className="flex items-center"><MapPin className="h-5 w-5 mr-2" /> Sportzaal 't Venster, Groot Vijverdal, Arnhem</p>
              <p className="flex items-center"><FileText className="h-5 w-5 mr-2" /> KvK nummer: 96646101</p>
              <p className="flex items-center"><CreditCard className="h-5 w-5 mr-2" /> IBAN: NL67 TRIO 0321038762</p>
            </div>
          </div>
          <div className="flex flex-col items-start">
            <h3 className="text-lg font-semibold mb-4">Trainingstijden</h3>
            <div className="space-y-2">
              <p>Dinsdag: 20:00 - 21:30</p>
              <p>Zondag: 10:30 - 12:00</p>
            </div>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Documenten</h3>
            <div className="space-y-2">
              <a
                href="/documents/HuishoudelijkReglementAnshin05092025.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center hover:text-gray-300 transition-colors"
              >
                <FileText className="h-5 w-5 mr-2" />
                Huishoudelijk Reglement
              </a>
            </div>
          </div>
          <div className="flex flex-col items-start">
            <h3 className="text-lg font-semibold mb-4">Volg ons</h3>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=61569080980116" target="_blank" rel="noopener noreferrer" className="hover:text-[#D7790F]">Facebook</a>
            </div>
          </div>
        </div>
        <div className="mt-6 md:mt-0 grid grid-cols-12 md:grid-cols-3 gap-10">
          <div className="flex justify-center md:justify-end md:col-span-0 md:col-start-2 md:pl-32">
            <div className="flex flex-wrap md:flex-nowrap gap-4">
              {footerBadges.map((badge: FooterBadge) => (
                <img
                  key={badge.alt}
                  src={badge.src}
                  alt={badge.alt}
                  loading="lazy"
                  className={`h-14 w-auto object-contain flex-shrink-0 ${badge.orderClass}`}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-700 text-center">
          <p>&copy; {new Date().getFullYear()} Anshin Aikido Arnhem. Alle rechten voorbehouden.</p>
        </div>
      </div>
    </footer>
  );
}